enum Subject {
  ART = 'Art',
  COMPUTER_SCIENCE = 'Computer Science',
  LANGUAGE_ARTS = 'English Language Arts',
  MATH = 'Math',
  READING = 'Reading',
  OTHER = 'Other', // Other will show as whatever text the user entered
  SCIENCE = 'Science',
  SOCIAL_STUDIES = 'Social Studies',
}

export default Subject;
